/** Pasif domainden ana domaine yönlendirme kararı (saf fonksiyon). */
const clean = (host) => String(host || '').toLowerCase().replace(/^www\./, '').replace(/\.$/, '');

export const passiveDomainTarget = (domains, location) => {
  if (!domains || domains.redirect_passive === false) return '';
  const primary = clean(domains.primary);
  if (!primary || !location) return '';
  const host = clean(location.hostname);
  if (!host || host === primary) return '';
  if (/^\/admin(\/|$)/.test(location.pathname || '')) return '';
  const passive = (domains.passive || []).map(clean);
  if (!passive.includes(host)) return '';
  return `https://${primary}${location.pathname || '/'}${location.search || ''}${location.hash || ''}`;
};
